import { SlipEntry } from 'types/SlipEntry';
import { ThemeIcon } from 'components/ThemeIcon/ThemeIcon';
import styles from './MatchBetList.module.css';
import { getOddLabel, marketLineSuffix } from 'components/Slip/Slip';
import { useContext } from 'react';
import { SlipContext } from 'context/slipContext';
import { useTranslation } from 'react-i18next';
import { translateBetMarketName } from 'helpers/betI18n';

interface Props {
  entry: SlipEntry;
  closeModal: () => void;
}
export const MatchBetList = ({ entry, closeModal }: Props) => {
  const { removeSlipEntry } = useContext(SlipContext);
  const { t } = useTranslation();

  return (
    <div className={styles.wrapper}>
      <div className={styles.title}>
        {entry.match.home?.name ??
          (typeof entry.match.league === 'string'
            ? entry.match.league
            : entry.match.league?.name) ??
          'Unknown'}{' '}
        - {entry.match.away?.name ?? '-'}
      </div>
      {entry.bets.map((bet, index) => (
        <div
          className={styles.betWrapper}
          key={index}
          onClick={() => {
            if (entry.bets.length === 1) closeModal();

            removeSlipEntry(entry.match, bet.bet, bet.odd);
          }}
        >
          <span>
            {translateBetMarketName(bet.bet, t)}
            {marketLineSuffix(bet.bet.name, bet.odd)}
          </span>
          <span>{getOddLabel(bet.odd, t, bet.bet.name)}</span>
          <span>
            <span>{bet.odd.odds}</span>
            <ThemeIcon icon="delete" alt="Remove" variant="inline" />
          </span>
        </div>
      ))}
      <div className={styles.iconsWrapper}>
        <div onClick={closeModal}>
          <ThemeIcon icon="arrow-left" alt="Back" variant="inline" />
        </div>
        <div
          onClick={() => {
            removeSlipEntry(entry.match);
            closeModal();
          }}
        >
          <ThemeIcon icon="trash" alt="Back" variant="inline" />
        </div>
      </div>
    </div>
  );
};
